<template>
  <div class="workflow-temp-viewer">
    <div class="workflow-temp-header mb-4">
      <div class="mb-3">
        <strong>ID:</strong>
        <p class="text-muted">{{ registro.id || '-' }}</p>
      </div>

      <div class="mb-3">
        <strong>Número REC:</strong>
        <p class="text-muted">{{ registro.numero_rec || '-' }}</p>
      </div>

      <div class="mb-3">
        <strong>Status:</strong>
        <p class="text-muted">{{ statusProcessamento }}</p>
      </div>

      <div class="mb-3">
        <strong>External:</strong>
        <p class="text-muted">{{ statusExternal }}</p>
      </div>

      <div class="mb-3">
        <strong>Tentativas:</strong>
        <p class="text-muted">{{ registro.tentativas_processamento ?? 0 }}</p>
      </div>

      <div class="mb-3">
        <strong>Processado em:</strong>
        <p class="text-muted">{{ formatarData(registro.processado_em) }}</p>
      </div>

      <div class="mb-3">
        <strong>Criado em:</strong>
        <p class="text-muted">{{ formatarData(registro.created_at) }}</p>
      </div>

      <div class="mb-3" v-if="registro.erro_processamento">
        <strong>Erro de processamento:</strong>
        <p class="text-danger">{{ registro.erro_processamento }}</p>
      </div>
    </div>

    <hr>

    <div class="workflow-temp-body">
      <strong>Payload original:</strong>
      <pre class="workflow-temp-content border p-3 mt-2">{{ payloadOriginalFormatado }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisualizarPcoWorkflowTempComponent',

  props: {
    registro: {
      type: Object,
      required: true
    }
  },

  computed: {
    statusProcessamento() {
      if (this.registro.erro_processamento) {
        return 'Processado com erro'
      }

      return this.registro.processado ? 'Processado com sucesso' : 'Pendente'
    },

    statusExternal() {
      if (this.registro.tem_external === true) {
        return 'Com external'
      }

      if (this.registro.tem_external === false) {
        return 'Sem external'
      }

      return 'Nao classificado'
    },

    payloadOriginalFormatado() {
      const payload = this.registro.payload_original?.xml_original ?? this.registro.payload_original

      if (!payload) {
        return '-'
      }

      if (typeof payload === 'string') {
        return payload
      }

      return JSON.stringify(payload, null, 2)
    }
  },

  methods: {
    formatarData(data) {
      if (!data) return '-'

      const date = new Date(data)

      if (Number.isNaN(date.getTime())) {
        return data
      }

      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.workflow-temp-viewer {
  max-height: 600px;
  overflow-y: auto;
}

.workflow-temp-header {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
}

.workflow-temp-content {
  background-color: #fafafa;
  border-radius: 4px;
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>